// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2hYxu","item":"PaymentsMobile_item__2QFd2","label":"PaymentsMobile_label__2dJN_","amount":"PaymentsMobile_amount__18Btr"};